module.exports = __webpack_public_path__ + "img/lesson_02.0749fc00.jpg";